'use strict';

const api = {
  cinema: {
    url: '/aliansce/shopping/rest/cinema/filmes.json',
  },
};

function checkValidData(data, texto404, filmesTexto) {
  if (!data.Sucesso || data.response === undefined) {
    if (filmesTexto) {
      filmesTexto.style.display = 'block';
    }

    return;
  }

  if (data.httpcode === 404) {
    if (filmesTexto) {
      const h2 = filmesTexto.querySelector('h2');

      if (h2) h2.insertAdjacentHTML('afterbegin', texto404 + '<br>');

      filmesTexto.style.display = 'block';
    }

    return;
  }
}

async function fetchMovies(hasNoMovies, moviesContainer, loadingElement) {
  if (hasNoMovies !== 'true') {
    try {
      const res = await fetch(api.cinema.url);
      const data = await res.json();

      return data;
    } catch (err) {
      createError(err);
    } finally {
      loadingElement.style.display = 'none';
      moviesContainer.style.display = 'block';
    }
  } else {
    loadingElement.style.display = 'none';
  }
}

function createError(err) {
  console.error('Erro ao carregar filmes:', err);
}

function sortByHour(a, b) {
  return a.hora > b.hora ? 1 : -1;
}

function checkIfDateIsToday(prDate) {
  const date = new Date();

  date.setHours(0, 0, 0, 0);

  prDate = new Date(prDate.split('-').join('/'));
  prDate.setHours(0, 0, 0, 0);

  if (date.getTime() === prDate.getTime()) {
    return true;
  } else {
    return false;
  }
}

// Recupera a primeira sessão considerando as salas dos filmes
function getFirstSession(prRooms) {
  const sessions = [];

  prRooms.forEach(e => {
    if (e.sessoes && e.sessoes.length > 0) {
      const session = new Object();
      const s = e.sessoes[0];

      session.sala = e.nome;

      session.dataHora = s.horario.dataHora;
      session.hora = s.horario.hora;
      session.diaMes = s.horario.diaMes;
      session.urlCompra = s.urlCompra;
      session.tipos = s.tipos;

      sessions.push(session);
    }
  });

  sessions.sort(sortByHour);

  if (sessions.length > 0) {
    return sessions[0];
  } else {
    return null;
  }
}

function getClassificacaoEtaria(classificacao) {
  const texto = classificacao.toLowerCase().trim();

  if (texto === 'livre') {
    return '<div class="dsa-cinema__classificacao" data-classificacao="L">L</div>';
  }

  const idade = texto.match(/\d+/);

  // Caso não seja livre e não tenha idade de número envolvida. Ex: "verifique a classificação"
  if (!idade) {
    return `
      <span class="dsa-text-body-small dsa-text-ambient-grayscale-20">
        ${texto[0].toUpperCase()}${texto.slice(1)}
      </span>
    `;
  }

  return `
    <div class="dsa-cinema__classificacao" data-classificacao="${idade[0]}">
      ${idade[0]}
    </div>
  `;
}

function getTypes(session) {
  let types = '';

  session.tipos.forEach(e => {
    types += '<span class="dsa-badge dsa-badge-sm dsa-badge-neutral2">' + e.apelido + '</span>';
  });

  return types;
}

function getOtherSessionsHTML(movie, isPreSaleList, fGetTypes) {
  let otherSessionsHTML = '';

  if (movie.exibicoes && movie.exibicoes.length > 0) {
    otherSessionsHTML += getOtherSessions(movie.exibicoes[0].salas);
  }

  return otherSessionsHTML;
}

function getOtherSessions(rooms) {
  const sessions = getSortSessionsByRooms(rooms);

  let otherSessions = '';

  if (sessions.length > 1) {
    for (let i = 1; i < sessions.length; i++) {
      otherSessions += getSessionHTML(sessions[i], false);
    }
  }

  return otherSessions;
}

function getSelectSessionHTML(outrasSessoes) {
  const exibicoes = outrasSessoes.exibicoes ?? [];

  if (exibicoes.length === 0) return '';

  const sessions = getSortSessionsByRooms(exibicoes[0].salas);

  if (sessions.length <= 1) return '';

  const options = sessions
    .map(
      s => `
        <option value="${s.id}" data-urlCompra="${s.urlCompra}">
          ${s.sala} | ${s.hora}H${getSelectSessionTypesHTML(s)}
        </option>`,
    )
    .join('');

  return `
    <select name="otherSessions" class="dsa-select otherSessionsSelect">
      <option value="" disabled selected>Próxima sessão</option>
      ${options}
    </select>
  `;
}

function getSelectSessionTypesHTML(session) {
  let types = '';

  session.tipos.forEach(e => {
    types += ' | ' + e.apelido;
  });

  return types;
}

function getSessionHTML(session, isFirstSession) {
  if (!session) return '';

  const hiddenAttr = isFirstSession ? '' : 'style="display:none;"';

  return `
    <div class="dsa-d-flex dsa-gap-xs dsa-align-items-center dsa-justify-content-between" ${hiddenAttr} data-session-id="${
      session.id
    }">
      <div class="dsa-d-flex dsa-flex-direction-column dsa-gap-xs">
        <span class="dsa-text-body-small dsa-text-function-secondary-active">
          ${session.sala} | ${session.hora}H
        </span>
        <div class="dsa-d-flex dsa-gap-2xs">
          ${getTypes(session)}
        </div>
      </div>
      <a target="_blank" rel="noopener noreferrer"
         href="${session.urlCompra}"
         class="dsa-link dsa-link-primary-inverse dsa-link-sm dsa-text-decoration-none callModalBuy">
        Comprar <span class="material-symbols-outlined">chevron_right</span>
      </a>
    </div>
  `;
}

function getSortSessionsByRooms(rooms) {
  if (!rooms) return [];

  const sessions = rooms.flatMap(room =>
    room.sessoes.map(s => ({
      id: s.id,
      sala: room.nome,
      hora: s.horario.hora,
      urlCompra: s.urlCompra,
      tipos: s.tipos,
      dataHora: s.horario.dataHora,
      diaMes: s.horario.diaMes,
    })),
  );

  return sessions.sort(sortByHour);
}

function getFilterByDay(moviesPerDayJSON, isDetailsPage) {
  if (!moviesPerDayJSON) return '';

  const { data, dataFormatada, diaSemana } = moviesPerDayJSON;
  const formattedDate = dataFormatada.replace('/', '-');

  const weekDay = checkIfDateIsToday(data)
    ? 'Hoje'
    : diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1, 3).toLowerCase();

  let dataLayerOnClick = '';

  if (isDetailsPage) {
    dataLayerOnClick = `onclick="dataLayerCinemaDetailsDateFilterClick('${dataFormatada}', '${weekDay}')"`;
  } else {
    dataLayerOnClick = `onclick="dataLayerCinemaListDateFilterClick('${dataFormatada}', '${weekDay}')"`;
  }

  return `
    <button ${dataLayerOnClick} class="filtroMovies dsa-pb-sm dsa-flex-1" id="movies--${formattedDate}">
      <p>${dataFormatada}</p>
      <span>${weekDay}</span>
    </button>
  `;
}

function createMovieObject(prMovie, prDate, prFormattedDate, prWeekDay) {
  if (!prMovie) return null;

  const {
    id,
    titulo,
    distribuidor,
    duracao,
    classificacaoEtaria,
    urlFilme,
    urlFilmeCinema,
    sinopse,
    estreia,
    imagens = [],
    trailers = [],
    generos,
    salas = [],
  } = prMovie;

  const primeiraSessao = salas.length > 0 ? getFirstSession(salas) : null;
  const primeiraSessaoDataHora = primeiraSessao?.dataHora;
  const estreiaDataHora = estreia?.dataHora;

  // Se não há nenhuma sessão nem estreia, ignora o filme
  if (!primeiraSessaoDataHora && !estreiaDataHora) {
    return null;
  }

  const movie = {
    id,
    titulo,
    distribuidor,
    duracao,
    classificacaoEtaria,
    urlFilme,
    urlFilmeCinema,
    sinopse: sinopse ?? 'Sinopse não disponível',
    estreia: estreiaDataHora,
    primeiraSessao: primeiraSessao ? { ...primeiraSessao, tipoFilme: undefined } : undefined,
    imagem: imagens[0]?.url ?? defaultImage,
    trailer: trailers[0]?.urlEmbutida,
    generos,
  };

  if (salas.length > 0 && prDate && prFormattedDate && prWeekDay) {
    const isToday = checkIfDateIsToday(prDate);
    const weekDay = isToday ? 'Hoje' : prWeekDay.slice(0, 3);

    movie.exibicoes = [
      {
        data: prDate,
        dataFormatada: prFormattedDate,
        diaSemana: weekDay,
        salas,
      },
    ];
  }

  return movie;
}

function trailerModalInit(movieName) {
  MicroModal.show('movieTrailer', {
    onShow: () => {
      dataLayerCinemaListTrailerModalImpression(movieName);
    },
    onClose: modalEl => {
      const iframe = modalEl.querySelector('iframe');

      if (!iframe) return;

      const { src } = iframe;

      iframe.src = '';
      iframe.src = src;
    },
  });
}

function generateDataLayer(dataLayerFunction, args = []) {
  const argsString = args.map(arg => JSON.stringify(arg)).join(', ');

  return `
    <script>
      document.addEventListener('DOMContentLoaded', () => {
        if (typeof ${dataLayerFunction} === 'function') {
          ${dataLayerFunction}(${argsString});
        }
      });
    </script>
  `;
}
